import React, { FC, useEffect, useMemo, useState } from 'react'

import { Button, Typography } from '@material-ui/core'
import { ConfirmationModal } from './ConfirmationModal';
import { apiClient } from '@/api/client';
import { IdVerificationModel } from '@/models/id-verifications';

interface Props {
  readonly reservationId: string;
}

const PropertyInfo: FC<Props> = ({ reservationId }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [verification, setVerification] = useState<IdVerificationModel | null>(null)
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false)
  const isButtonDisabled = verification?.state === undefined || verification.state === 'approved' || isLoading

  const statusText = useMemo(() => {
    if (isLoading) {
      return 'loading...'
    }

    if (verification?.state === undefined) {
      return 'no status available'
    }

    return verification.state
  }, [verification, isLoading])

  async function getIdVerificationStatus() {
    setIsLoading(true)

    try {
      const [result] = await Promise.all([
        await apiClient.idVerifications.getVerification(reservationId),
        await new Promise((resolve) => setTimeout(resolve, 500))
      ])

      console.log('Id verification result:', result)

      if (result) {
        setVerification(result)
      }
    } finally {
      setIsLoading(false)
    }
  }

  async function approveIdVerification() {
    if (verification?.id !== undefined) {
      try {
        setIsLoading(true)
        const result = await apiClient.idVerifications.approveVerification(verification.id)

        setVerification(result)
      } finally {
        setIsLoading(false)
      }
    }
  }

  useEffect(() => {
    getIdVerificationStatus();
  }, []);

  return (
    <div>
      <h2>Id verification</h2>

      <Typography>
        Status: <strong>{statusText}</strong>
      </Typography>

      <br />

      <Button
        onClick={() => setIsConfirmationVisible(true)}
        variant="outlined"
        disabled={isButtonDisabled}
      >
          Approve ID verification
      </Button>

      <ConfirmationModal
        show={isConfirmationVisible}
        onSubmit={approveIdVerification}
        onClose={() => setIsConfirmationVisible(false)}
        confirmButtonText="Approve ID"
      >
        <p>Are you sure you want to approve the ID?</p>
      </ConfirmationModal>
    </div>
  )
}

export default PropertyInfo
